import { render, staticRenderFns } from "./CatalogShoppingItem.vue?vue&type=template&id=28d71b3c&scoped=true&"
import script from "./CatalogShoppingItem.vue?vue&type=script&lang=ts&"
export * from "./CatalogShoppingItem.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogShoppingItem.vue?vue&type=style&index=0&id=28d71b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d71b3c",
  null
  
)

export default component.exports